interface Props {
  children: React.ReactNode;
  tone?: 'info' | 'danger';
}

export function BetNote({ children, tone = 'info' }: Props) {
  const color = tone === 'danger' ? 'var(--danger)' : 'var(--primary)';
  return (
    <p
      className="text-[11px] text-[var(--text-secondary)] rounded-md px-2.5 py-2 bg-[var(--bg-sunken)] border border-[var(--border)]"
      style={{ borderLeft: `3px solid ${color}` }}
    >
      {children}
    </p>
  );
}
